<div fxFlex="100%" fxLayout="column" fxLayoutGap="20px">
  <p8-role-entites *ngIf="isAdmin || isSuperGest"
    [role]="'gestionnaire_demat'"
    [role_label]="'Gestionnaires'"
    [role_description]="'Accès gestionnaires : Gestion de formulaire'"
    [message_confirmation]="'Confirmez-vous la suppression des droits pour cette personne ?'"

    [entite]="'demat'"

    [scope]="true"
    [defaultScopes]="'employee,faculty,researcher'"

    [urlApiRole]="urlApi"
    [urlApiIndividu]="urlApiIndividu">
  </p8-role-entites>

  <p8-role-entites *ngIf="isAdmin"
                   [role]="'superviseur_demat'"
                   [role_label]="'Superviseurs'"
                   [role_description]="'Accès superviseurs : Gestion de plusieurs formulaires'"

                   [entite]="'demat'"

                   [scope]="true"
                   [defaultScopes]="'employee,faculty,researcher'"

                   [urlApiRole]="urlApi"
                   [urlApiIndividu]="urlApiIndividu">
  </p8-role-entites>

  <p8-role-entites *ngIf="isAdmin"
                   [role]="'admin_demat'"
                   [role_label]="'Administrateurs'"
                   [role_description]="'Accès administrateurs'"

                   [entite]="'demat'"

                   [scope]="true"
                   [defaultScopes]="'employee'"

                   [urlApiRole]="urlApi"
                   [urlApiIndividu]="urlApiIndividu">
  </p8-role-entites>

</div>
